let _jurTab='processos',_contratosAno=new Date().getFullYear(),_contratosMes='',_contratosTab='clientes';

function switchJurTab(tab){
  _jurTab=tab;
  ['processos','contratos','saude'].forEach(t=>{
    const btn=document.getElementById('jur-tab-'+t);
    const panel=document.getElementById('jur-panel-'+t);
    if(btn)btn.classList.toggle('active',t===tab);
    if(panel)panel.style.display=t===tab?'':'none';
  });
  const novoBtn=document.getElementById('jur-novo-btn');
  if(novoBtn)novoBtn.style.display=tab==='processos'?'':'none';
  if(tab==='contratos')renderContratosFormalizados();
  if(tab==='saude')renderSaudeFiscal();
}

